// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__cLFAI","Alert":"Layout_Alert__WRSmP"};